<template>
  <div>
    <el-drawer :visible.sync="whatNearbyShowInside" :title="$t('whatNearby')" size="85%" class="search-dialog hotel-detail-around" :with-header="false" @close="dialog_close('whatNearbyShow')" :modal-append-to-body="false">
        <!-- <div class="search-header">
            <div class="search-center">
                <div class="search-back" @click="dialog_close('whatNearbyShow')"> <i class="el-icon-arrow-left"></i> </div>
                <div class="search-title" v-html="$t('whatNearby')"></div>
                <div class="search-close"></div>
            </div>
        </div> -->
        <div style="text-align:left">
          <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
            <div @click="dialog_close('whatNearbyShow')">
              <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
            </div>
            <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;" v-html="$t('whatNearby')"></div>
          </div>
        </div>
        <div class="search-line"></div>
        <div class="search-line hotel-detail-around-line" v-for="(item, t) in travelAround" :key="t">
            <img src="https://res.roompai.com/static/img/hotelsearch/explore-addr.png" alt="">
            <span class="hotel-detail-around-name">
              <span v-html="getLanguageHtml(item.desc,'desc')"></span>
            </span>
            <span class="hotel-detail-around-time around-line-mileage" v-html="getLanguageHtml(item.time,'time')"></span>
        </div>
        <!-- <div class="demarcation-line" style="width:100%">
          <img src="/static/img/hotelsearch/division.svg" alt="">
        </div> -->
    </el-drawer>
    <div style="clear:both"></div>

    <el-drawer :visible.sync="facilitiesShowInside" :title="$t('facilities')" size="85%" class="search-dialog hotel-detail-around" :with-header="false" @close="dialog_close('facilitiesShow')"  :modal-append-to-body="false">
        <!-- <div class="search-header">
            <div class="search-center">
                <div class="search-back" @click="dialog_close('facilitiesShow')"> <i class="el-icon-arrow-left"></i> </div>
                <div class="search-title">{{$t('facilities')}}</div>
                <div class="search-close"></div>
            </div>
        </div> -->
        <div style="text-align:left">
          <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
            <div @click="dialog_close('facilitiesShow')">
              <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
            </div>
            <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('facilities')}}</div>
          </div>
        </div>
        <div class="overview-instructions-data" >
            <ul>
                <li v-for="(facilities,k) in hotelFacilities" :key="k"  :class="[{'inst-title': facilities.parent === 1, 'inst-title-top': facilities.parent === 1 && k != 0, 'inst-cont': facilities.parent !== 1}]" style="width: 84%;height: 25px;">
                    <!-- <span v-if="facilities.parent === 1">·</span> -->
                    <span v-if="facilities.parent === 1" style="width: 20px;height: 20px;display: inline-block; vertical-align: top;">
                      <img alt="" :src="facilities.img" class="inst-img">
                    </span>
                    <span v-else style="width: 20px;height: 20px;display: inline-block;vertical-align: top;"></span>
                    <span class="inst-text" v-html="getLanguageHtml(facilities,'facilities')" style="vertical-align: top;overflow: hidden;white-space: nowrap;display: inline-block;width: 88%;height: 100%;text-overflow: ellipsis;" v-bind:title="getLanguageHtml(facilities,'facilities')"></span>
                </li>
            </ul>
        </div>
        <!-- <div class="search-line search-top"></div> -->
    </el-drawer>
    <div style="clear:both"></div>

    <el-drawer :visible.sync="hotelPriceRoomImgShowInside" :title="getLanguageHtml(hotelPriceRoom, 'roomname')" size="85%" class="search-dialog hotel-detail-around" :with-header="false" @close="dialog_close('hotelPriceRoomImgShow')"  :modal-append-to-body="false">
        <div style="text-align:left">
          <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
            <div @click="dialog_close('hotelPriceRoomImgShow')" style="width: 10%;height: 100%;float: left;">
              <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
            </div>
            <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;width: 85%;" v-html="getLanguageHtml(hotelPriceRoom, 'roomname')"></div>
          </div>
        </div>
        <div :style="{lineHeight: docHeight}">
          <img :src="hotelPriceRoom.url" style="width:100%;vertical-align: middle;">
        </div>
        <!-- <div class="search-line search-top"></div> -->
    </el-drawer>
    <div style="clear:both"></div>

  </div>
</template>

<script>
export default {
  name: 'publicHotelDetailInfo',
  props: ['whatNearbyShow', 'facilitiesShow', 'travelAroundData', 'hotelFacilitiesData', 'hotelPriceRoomImgShow', 'hotelPriceRoomData'],
  data () {
    return {
      whatNearbyShowInside: false,
      facilitiesShowInside: false,
      hotelPriceRoomImgShowInside: false,
      travelAround: this.travelAroundData,
      hotelFacilities: this.hotelFacilitiesData,
      hotelPriceRoom: {'url': '', 'roomname': ''},
      docHeight: document.documentElement.clientHeight + 'px'
    }
  },
  watch: {
    whatNearbyShow: function (news, olds) {
      console.log('whatNearbyShow')
      console.log(news, olds)
      this.whatNearbyShowInside = news
    },
    facilitiesShow: function (news, olds) {
      console.log('facilitiesShow')
      console.log(news, olds)
      this.facilitiesShowInside = news
    },
    hotelPriceRoomImgShow: function (news, olds) {
      console.log('hotelPriceRoomImgShow')
      console.log(news, olds)
      this.hotelPriceRoomImgShowInside = news
    },
    travelAroundData: function (news) {
      this.travelAround = news
    },
    hotelFacilitiesData: function (news) {
      this.hotelFacilities = news
    },
    hotelPriceRoomData: function (news) {
      this.hotelPriceRoom = news
    }
  },
  created () {},
  beforeMount () {},
  mounted () {},
  methods: {
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['facilities', 'desc', 'time'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (type === 'roomname') {
        if (getLanguage === 'zh') {
          return data.name_cn + ' (' + data.name_en + ')'
        } else {
          return data.name_en
        }
      }
    },
    dialog_close: function (type) {
      this.$emit('closepop', type)
    }
  }
}
</script>

<style scoped>
  .search-dialog{width:100%;height:auto;}
  /*.search-dialog div{overflow:hidden;}*/
  /deep/ .search-dialog{z-index:20000!important;}
  .search-dialog .search-header{width:100%;min-height:50px;background:rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;}
  .search-dialog .search-center{width:95%;height:100%;margin:0 auto;overflow:auto;}
  .search-dialog .search-header .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
  .search-dialog .search-header .search-center .search-close{width:15%;height:100%;float:left;}
  .search-dialog .search-header .search-center .search-title{width:70%;height:100%;float:left;}
  .search-dialog .search-line{width:100%;min-height:30px;background:white;line-height:50px;text-align:left;font-size:16px;}
  .search-dialog .search-line span{margin-left:1%;}
  .search-dialog .search-top{border-top:solid 1px #DCDFE2;}

  /* 周边*/
  .hotel-detail-around .hotel-detail-around-line{width:100%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 14px;color: #4F4C4C;padding-left: 20px;overflow-y: scroll;}
  .hotel-detail-around .more-line{width:100%;height:6%;font-family: PingFangSCRegular, 'PingFang SC Light', 'PingFang SC', sans-serif;font-weight: 200;font-style: normal;font-size: 10px;color:#5392F9;cursor:pointer;}
  .hotel-detail-around .first-line{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 16px;color: #4F4C4C;}
  .hotel-detail-around .hotel-detail-around-line img{width:20px;height:14px;float:left;margin-top:2px;}
  .hotel-detail-around .hotel-detail-around-line .hotel-detail-around-name{float: left;display: block;font-size:12px;width: 55%;}
  .hotel-detail-around .hotel-detail-around-line .hotel-detail-around-name span{line-height: 20px;display:block;}
  .hotel-detail-around .hotel-detail-around-line .hotel-detail-around-time{float: right;line-height: 22px;padding-right: 8px;display: block;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;font-size:12px;width: 30%}
  .hotel-detail-around-line .around-line-mileage{text-align:right; font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 10px;color:#A6A6A6;}

  /* 设施 */
  .overview-instructions-data{width:96%;padding:20px 10px;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif; font-style: normal;font-size: 14px;text-align: left;line-height: 26px;overflow-x: auto;}
  .overview-instructions-data::-webkit-scrollbar { display: none;}
  .overview-instructions-data ul{height: 100%;font-size:14px;-webkit-column-gap: 12px;-webkit-column-count: 1;column-gap: 12px;column-count: 1;-moz-column-gap: 12px;-moz-column-count: 1;-moz-column-rule: 1px solid #d8d8d8;}
  .overview-instructions-data ul li{display:block;}
  .inst-title{font-weight: 650;}
  .inst-cont{font-weight: 400;font-size:12px;}
  .inst-title-top{margin-top: 16px;}
  .inst-title,.inst-title-top,.inst-cont .inst-text{vertical-align: middle;}
  .inst-img{width:20px;height:20px;vertical-align: text-top;}
  /deep/ .v-modal{z-index: 19999!important;}

  .hotel-room-clear{height:10px;}
  .demarcation-line {height:21px;}
  .demarcation-line img{width:100%;margin:10px 0px;}
</style>



// WEBPACK FOOTER //
// src/components/public/publicHotelDetailInfo.vue